<script>
import { defineComponent, h } from "vue";

export default defineComponent({
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    classPanelFun: {
      type: String,
      default: "btn-group mr-1",
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const createDropdownMenu = (items) => {
      const result = [];

      for (const key in items) {
        const item = items[key];
        if (!item) continue;

        const elements = [];
        if (item.icon) elements.push(item.icon);
        if (!props.iconOnly && item.caption) elements.push(` ${item.caption}`);

        if (item.items) {
          result.push(
            h("div", { class: "dropdown-submenu" }, [
              h("a", { href: "#", class: "dropdown-item" }, elements),
              h(
                "div",
                { class: "dropdown-menu" },
                createDropdownMenu(item.items),
              ),
            ]),
          );
        } else {
          const params = {
            href: "#",
            class: "dropdown-item",
            title: item.title || null,
            onClick: item.onClick || null,
          };

          result.push(h("a", params, elements));
        }
      }

      return result;
    };

    return () => {
      const panels = [];

      for (const item of props.items) {
        const buttons = [];
        const dropdown = [];

        for (const key in item) {
          const button = item[key];
          if (!button || Object.keys(button).length === 0) continue;

          const elements = [];
          if (button.icon) elements.push(button.icon);
          if (!props.iconOnly && button.caption)
            elements.push(` ${button.caption}`);

          const classes = [button.class ? button.class : "btn btn-trig"];

          if (button.items) {
            classes.push("dropdown-toggle");

            dropdown.push(
              h(
                "div",
                {
                  class: "dropdown-menu",
                  style:
                    "position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 36px, 0px);",
                },
                createDropdownMenu(button.items),
              ),
            );
          }

          const params = {
            type: "button",
            class: classes.join(" "),
            title: button.title || null,
            "data-toggle": button.items ? "dropdown" : null,
            onClick: button.onClick || null,
          };

          buttons.push(h("button", params, elements));
        }

        panels.push(
          h("div", { class: props.classPanelFun }, [...buttons, ...dropdown]),
        );
      }

      return h("div", { class: "btn-toolbar" }, panels);
    };
  },
});
</script>

<style></style>
